/* Littos — expo photo-review page (/pages/taste). No dependencies.
   Landing → Judge.me photo review (new tab) → back here → "SHOW THE CREW" → claim code.
   The code only appears after the review link was opened; the crew also checks
   Judge.me's thank-you screen before handing over the tin. Rating is never read here.
   The claim stays on this phone (localStorage); staff can clear it with ?reset=1. */
(function () {
  'use strict';

  var root = document.getElementById('LtTaste');
  if (!root || root.__ltInit) return;
  root.__ltInit = true;

  var CLAIM_KEY = 'littos_taste_claim_v2';
  var OPENED_KEY = 'littos_taste_opened_v2';
  var CODE_CHARS = '23456789ABCDEFGHJKLMNPQRSTUVWXYZ';

  var $ = function (s) { return root.querySelector(s); };
  var $$ = function (s) { return Array.prototype.slice.call(root.querySelectorAll(s)); };

  function store(k) { try { return window[k]; } catch (e) { return null; } }
  function read(k, key) { try { var s = store(k); return s ? JSON.parse(s.getItem(key) || 'null') : null; } catch (e) { return null; } }
  function write(k, key, v) { try { var s = store(k); if (s) s.setItem(key, JSON.stringify(v)); } catch (e) {} }
  function remove(k, key) { try { var s = store(k); if (s) s.removeItem(key); } catch (e) {} }
  function clean(v) { return String(v || '').toLowerCase().replace(/[^a-z0-9-]+/g, '-').replace(/^-+|-+$/g, '').slice(0, 60); }

  var params = new URLSearchParams(location.search);
  var eventName = clean(params.get('event')) || clean(root.getAttribute('data-default-event')) || 'expo';
  if (params.get('reset') === '1') {
    remove('localStorage', CLAIM_KEY); remove('sessionStorage', OPENED_KEY);
    params.delete('reset');
    var qs = params.toString();
    history.replaceState(null, '', location.pathname + (qs ? '?' + qs : ''));
  }

  var landing = $('[data-screen="landing"]');
  var success = $('[data-screen="success"]');
  var stageGo = $('[data-stage="go"]');
  var stageBack = $('[data-stage="back"]');

  function showStage(opened) {
    stageGo.hidden = opened;
    stageBack.hidden = !opened;
  }

  $$('[data-review-go]').forEach(function (a) {
    a.addEventListener('click', function () {
      write('sessionStorage', OPENED_KEY, { at: Date.now() });
      // Swap after the new tab opens so they see "SHOW THE CREW" when they come back.
      setTimeout(function () { showStage(true); }, 300);
    });
  });

  function makeCode() {
    var out = '', b = new Uint8Array(4);
    if (window.crypto && crypto.getRandomValues) crypto.getRandomValues(b);
    else for (var j = 0; j < 4; j++) b[j] = Math.floor(Math.random() * 256);
    for (var i = 0; i < 4; i++) out += CODE_CHARS[b[i] % CODE_CHARS.length];
    return 'LIT-' + out;
  }

  function showClaim(c) {
    landing.hidden = true; landing.classList.remove('is-active');
    success.hidden = false; success.classList.add('is-active');
    $('[data-claim-code]').textContent = c.code;
    var d = new Date(c.at);
    $('[data-claim-meta]').textContent = isNaN(d) ? '' : d.toLocaleString(undefined, { day: 'numeric', month: 'short', hour: 'numeric', minute: '2-digit' });
    window.scrollTo(0, 0);
    var t = $('#LtSuccessTitle'); if (t) { try { t.focus({ preventScroll: true }); } catch (e) {} }
  }

  $('[data-claim]').addEventListener('click', function () {
    if (!read('sessionStorage', OPENED_KEY)) { showStage(false); return; }
    var c = { code: makeCode(), at: new Date().toISOString(), event: eventName };
    write('localStorage', CLAIM_KEY, c);
    showClaim(c);
  });

  var tagsInput = $('[data-loop-tags]');
  if (tagsInput) tagsInput.value = 'taste-feedback, expo, event-' + eventName;

  var claimed = read('localStorage', CLAIM_KEY);
  if (claimed && claimed.code) showClaim(claimed);
  else showStage(!!read('sessionStorage', OPENED_KEY));
})();
